var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEditLineGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 18.5H19V20.5H2V18.5Z",
    fill: "#77787D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5636 5.59091C19.1455 5.00909 19.1455 4.13636 18.5636 3.55455L15.9455 0.936364C15.3636 0.354545 14.4909 0.354545 13.9091 0.936364L3 11.8455V16.5H7.65455L18.5636 5.59091ZM14.9273 1.95455L17.5455 4.57273L15.3636 6.75455L12.7455 4.13636L14.9273 1.95455ZM4.45455 15.0455V12.4273L11.7273 5.15455L14.3455 7.77273L7.07273 15.0455H4.45455Z",
    fill: "#77787D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.666504 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditLineGray);
export default __webpack_public_path__ + "static/media/ic-edit-line-gray.32955e5619e012107bf9032f0781c9ad.svg";
export { ForwardRef as ReactComponent };